import { useEffect } from 'react';
import { apiClient } from '@common/http/query-client';

export interface useLogEventProps {
  event_type: string;
  entity_id?: string | number | null;
  entity_type?: string | null;
  metadata?: Record<string, any>
}

export const useLogEvent = (payload: useLogEventProps) => {
  

  useEffect(() => {
    if(payload.entity_type && !payload.entity_id) return;
    logEvent(payload);
    return;
  }, [payload]);
};

export const logEvent = ( payload: useLogEventProps) => {
  return apiClient.post(`events`, payload).then(r => r.data);
};
